var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM6.91421 5.42893C6.52369 5.03841 5.89052 5.03841 5.5 5.42893C5.10948 5.81946 5.10948 6.45262 5.5 6.84315L8.62057 9.96404L5.46447 13.1213C5.07394 13.5118 5.07394 14.145 5.46447 14.5355C5.85499 14.9261 6.48815 14.9261 6.87868 14.5355L10.0356 11.378L13.1569 14.5C13.5474 14.8905 14.1805 14.8905 14.5711 14.5C14.9616 14.1095 14.9616 13.4763 14.5711 13.0858L11.4496 9.96404L14.5355 6.87868C14.9261 6.48815 14.9261 5.85499 14.5355 5.46447C14.145 5.07394 13.5118 5.07394 13.1213 5.46447L10.0356 8.55004L6.91421 5.42893Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleError);
export default __webpack_public_path__ + "static/media/circle-error.e2e4d9f904cdbe646aa443bc04af75a9.svg";
export { ForwardRef as ReactComponent };